<template>
    <div class="text-center mt-5">
        <small class="d-block ma-auto" style="max-width: 250px;">Ready for the next step? Add this product to your cart to continue.</small>
        <br>
        <v-btn rounded="pill" class="w-75" size="large" id="add-to-quote-btn" prepend-icon="mdi-plus-circle" :color="ConfigElementsColor" @click="$emit('onAdd')">Add to Quote</v-btn>
    </div>
</template>

<script>
import {CommonMixins} from "@/mixins/CommonMixins";
export default {
    mixins: [CommonMixins]
}
</script>
